export const FETCH_PRICES_BEGIN = 'prices:FETCH_PRICES_BEGIN'
export const FETCH_PRICES_FAIL = 'prices:FETCH_PRICES_FAIL'
export const FETCH_PRICES_SUCCESS = 'prices:FETCH_PRICES_SUCCESS'
